
define('text!modules/media/closedSupply/templates/closedSupply.html',[],function () { return 'Closed supply section\n';});

